import type { RentCarSearchResult, RentCarVehicle } from '../../api/types/rentCar';

/**
 * RentCar/Search's real response shape for `carListingSearchResponse` could not be
 * confirmed against the real API (see api/types/rentCar.ts's RentCarSearchResponse
 * comment — this test account has no seeded RentCar locations, so a successful Search
 * response was unobtainable). Defensively looks for the vehicle list under a few
 * plausible key names instead of assuming one, so the results page still renders
 * correctly whichever key the real backend actually uses.
 */
const PLAUSIBLE_VEHICLE_LIST_KEYS = ['vehicles', 'cars', 'items', 'results', 'list', 'rentCars'];

export function extractVehicles(result: RentCarSearchResult | null | undefined): RentCarVehicle[] {
  if (!result) return [];
  if (Array.isArray(result.vehicles)) return result.vehicles;

  for (const key of PLAUSIBLE_VEHICLE_LIST_KEYS) {
    const value = result[key];
    if (Array.isArray(value)) return value as RentCarVehicle[];
  }

  return [];
}

export function formatCurrency(amount?: number, currency?: string | null): string {
  if (amount === undefined || amount === null) return '—';
  const formatted = amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return currency ? `${formatted} ${currency}` : formatted;
}

export function vehicleDisplayName(vehicle: RentCarVehicle): string {
  return (
    vehicle.name ||
    [vehicle.brand, vehicle.model].filter(Boolean).join(' ') ||
    vehicle.category ||
    vehicle.code ||
    vehicle.id ||
    'Araç'
  );
}
